import { Box, Skeleton } from '@mui/material';
import { isTouchEnabled } from '../../../../../../Theme';
import { CatalogProductsTestIds } from '../../../../../../utils/testIds/CatalogProducts.testIds';
import {
  COMBINATION_GRID_GAP_WIDTH,
  COMBINATION_PRICE_SECTION_WIDTH,
} from '../../../../../products/products-details-v2/components/CombinationLine/consts/combinationLine.consts';
import {
  CATALOG_LIST_CHECKBOX_GAP,
  CATALOG_LIST_CHECKBOX_SLOT_WIDTH,
  CATALOG_LIST_RIGHT_BLOCK_WIDTH,
  CATALOG_LIST_ROW_VERTICAL_PADDING,
  getCatalogListLeftColumnWidth,
  getCatalogListTopBlockHeight,
} from '../utils/catalogListRow.consts';

interface CatalogProductListRowSkeletonProps {
  isStacked: boolean;
  hasSelection: boolean;
}

const touchKey = isTouchEnabled ? 'touch' : 'mouse';

const SKELETON_ROW_SX = {
  height: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  overflow: 'hidden',
  paddingX: 1,
  paddingY: `${CATALOG_LIST_ROW_VERTICAL_PADDING}px`,
  backgroundColor: 'background.paper',
} as const;

const CatalogProductListRowSkeleton = ({
  isStacked,
  hasSelection,
}: CatalogProductListRowSkeletonProps) => {
  const checkboxSlot = hasSelection && (
    <Skeleton
      variant="rectangular"
      width={CATALOG_LIST_CHECKBOX_SLOT_WIDTH}
      height={CATALOG_LIST_CHECKBOX_SLOT_WIDTH}
      sx={{ flex: '0 0 auto', alignSelf: 'center' }}
    />
  );

  if (isStacked) {
    return (
      <Box
        test-id={CatalogProductsTestIds.PRODUCT_ROW_SKELETON}
        sx={{ ...SKELETON_ROW_SX, flexDirection: 'column' }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: `${CATALOG_LIST_CHECKBOX_GAP[touchKey]}px`,
          }}
        >
          {checkboxSlot}
          <Skeleton
            variant="rectangular"
            height={getCatalogListTopBlockHeight({ isStacked: true, isTouchEnabled })}
            sx={{ flex: '1 1 auto' }}
          />
          <Box sx={{ width: COMBINATION_PRICE_SECTION_WIDTH, flex: '0 0 auto' }} />
        </Box>

        <Skeleton variant="rectangular" sx={{ flex: 1 }} />
      </Box>
    );
  }

  return (
    <Box
      test-id={CatalogProductsTestIds.PRODUCT_ROW_SKELETON}
      sx={{ ...SKELETON_ROW_SX, gap: `${COMBINATION_GRID_GAP_WIDTH}px` }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: `${CATALOG_LIST_CHECKBOX_GAP[touchKey]}px`,
          flex: '0 1 auto',
          minWidth: 0,
          width: getCatalogListLeftColumnWidth({ isTouchEnabled, hasSelection }),
        }}
      >
        {checkboxSlot}
        <Skeleton variant="rectangular" height="100%" sx={{ flex: '1 1 auto' }} />
      </Box>

      <Skeleton variant="rectangular" height="100%" sx={{ flex: '1 0 0' }} />

      <Skeleton
        variant="rectangular"
        width={CATALOG_LIST_RIGHT_BLOCK_WIDTH}
        height="100%"
        sx={{ flex: '0 0 auto' }}
      />
    </Box>
  );
};

export default CatalogProductListRowSkeleton;
